export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14909.9f1c39ac.jpg";